// extracted by mini-css-extract-plugin
module.exports = {"file-upload":"file-upload__file-upload___3zKVr","file-text":"file-upload__file-text___8LOxB","selected-file":"file-upload__selected-file___3ltbz file-upload__file-text___8LOxB"};